import { queryOptions } from '@tanstack/vue-query';
import { PriorityQueryKey } from '@/modules/common/enums/query-key.enum.ts';
import { CategoryApi } from '@/modules/counterparty/api/category.api.ts';

export class CategoryQueryOptions {
  static BASE_KEY = 'category';

  static getList(signal?: AbortSignal) {
    return queryOptions({
      queryKey: [PriorityQueryKey.Secondary, CategoryQueryOptions.BASE_KEY],
      queryFn: (meta) => CategoryApi.getList(signal ?? meta.signal),
    });
  }
}
